"use strict";Object.defineProperty(exports, "__esModule", {value: true});// package.json
var version = "8.5.1";



exports.version = version;
